import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { DeleteButton } from '../../../components/DeleteButton';
import { EditButton } from '../../../components/EditButton';
import { CopyButton } from '../../../components/CopyButton';

import css from './UserEntry.module.scss';
import { GenericButton } from '../../../components/GenericButton';

export const UserEntry = ({ user, handleDelete, handleEdit, handleTokensEdit }) => {
      
    const getLabelWithMaxLength = (label, maxLenght) => {
        if (!label) {
            return null;
        }

        if (label.length <= maxLenght) {
            return <>{label}</>
        }

        const labelTrimmed = label.substring(0, maxLenght - 2).trim() + "...";

        return <>
            <OverlayTrigger 
                placement='right'
                overlay={
                    <Tooltip>
                        {label}
                    </Tooltip>
                }
            >
                <span>{labelTrimmed}</span>
            </OverlayTrigger>
        </>;
    }

    return (
        <tr>
            <td className="align-left">
                {user.name}
            </td>
            <td>
            <div className={css.flexContainer}>
                    <div>
                        {getLabelWithMaxLength(user.description, 100)}
                    </div>
                </div>
            </td>
            <td>
                <div className="d-flex align-items-center justify-content-between">
                    <span>{user.username}</span>
                    <CopyButton
                        className="float-end"
                        tooltip="Copy username"
                        onClick={() => navigator.clipboard.writeText(user.username)}
                    />
                </div>
            </td>
            <td>
                <div className="d-flex align-items-center justify-content-between">
                    <span>{user.password.substring(0, 3)} ●●●●●●●●●●</span>
                    <CopyButton
                        className="float-end"
                        tooltip="Copy password"
                        onClick={() => navigator.clipboard.writeText(user.password)}
                    />
                </div>
            </td>
            <td className="align-middle">
                <GenericButton className="float-end me-1" tooltip="Tokens" iconName="key" onClick={() => handleTokensEdit(user)} />
                <DeleteButton className="float-end me-1" tooltip="Delete" onClick={() => handleDelete(user)} />
                <EditButton className="float-end me-1" tooltip="Edit" onClick={() => handleEdit(user)} />                
            </td>
        </tr>
    )
}